const SEARCH_CONCEPTS = [
    ['fellowship', 'community', 'communities', 'belonging', 'friendship', 'relationships', 'togetherness', 'shared life', 'church family', 'membership'],
    ['church', 'congregation', 'assembly', 'ecclesia', 'body of christ'],
    ['pastor', 'pastors', 'minister', 'ministry', 'clergy', 'elder', 'elders', 'overseer', 'shepherd', 'church leader', 'church leadership'],
    ['sign', 'signs', 'confirmation', 'guidance', 'fleece', 'omen', 'omens', 'divination', 'testing prophecy'],
    ['holy spirit', 'spirit', 'charismatic', 'pentecostal', 'spiritual gifts', 'gifts of the spirit'],
    ['salvation', 'saved', 'saving', 'redemption', 'redeemed', 'eternal life'],
    ['sanctification', 'holiness', 'holy living', 'spiritual formation', 'christlikeness', 'christlike'],
    ['justification', 'righteousness', 'right standing', 'declared righteous'],
    ['baptism', 'baptised', 'baptized', 'christening', 'initiation'],
    ['communion', 'eucharist', 'lords supper', 'breaking bread', 'shared meal', 'table fellowship'],
    ['prayer', 'pray', 'intercession', 'petition', 'talking to god'],
    ['scripture', 'bible', 'biblical', 'word of god'],
    ['law', 'torah', 'commandment', 'commandments', 'mosaic covenant'],
    ['covenant', 'testament', 'promise', 'promises'],
    ['sin', 'sinful', 'wrongdoing', 'immorality', 'transgression'],
    ['repentance', 'repent', 'turning back', 'confession'],
    ['forgiveness', 'forgive', 'mercy', 'pardon', 'reconciliation'],
    ['hell', 'damnation', 'final punishment', 'eternal punishment', 'lake of fire'],
    ['heaven', 'afterlife', 'life after death', 'eternal life', 'new creation'],
    ['end times', 'last days', 'eschatology', 'second coming', 'return of christ'],
    ['rapture', 'caught up', 'second coming', 'return of christ'],
    ['free will', 'human freedom', 'choice', 'agency'],
    ['predestination', 'election', 'chosen', 'foreordination'],
    ['women in ministry', 'female leadership', 'women pastors', 'women leaders', 'women preaching'],
    ['marriage', 'matrimony', 'husband and wife', 'spouse', 'spouses'],
    ['divorce', 'separation', 'remarriage', 'marriage breakdown'],
    ['money', 'wealth', 'finances', 'possessions', 'riches'],
    ['poverty', 'poor', 'need', 'economic hardship'],
    ['work', 'employment', 'job', 'labour', 'labor', 'vocation'],
    ['government', 'state', 'civil authority', 'politics', 'political'],
    ['war', 'warfare', 'military', 'armed conflict', 'violence'],
    ['pacifism', 'nonviolence', 'non violence', 'peacemaking'],
    ['abortion', 'termination', 'unborn life'],
    ['alcohol', 'drinking', 'wine', 'drunkenness'],
    ['drugs', 'narcotics', 'substance use', 'recreational drugs'],
    ['pornography', 'porn', 'sexual images', 'explicit material'],
    ['fear', 'afraid', 'anxiety', 'reverence', 'awe'],
    ['love', 'charity', 'care', 'compassion'],
    ['justice', 'fairness', 'judgement', 'judgment'],
    ['judge', 'judges', 'judging', 'judgement', 'judgment', 'condemn', 'condemnation', 'discern'],
    ['enemy', 'enemies', 'opponent', 'opponents', 'adversary', 'adversaries'],
    ['anger', 'angry', 'rage', 'wrath'],
    ['envy', 'jealousy', 'jealous', 'coveting'],
    ['pride', 'arrogance', 'conceit', 'self importance'],
    ['contentment', 'content', 'satisfaction', 'enough'],
    ['gossip', 'rumour', 'rumor', 'slander', 'backbiting'],
    ['promise', 'promises', 'vow', 'vows', 'pledge', 'commitment'],
    ['faith', 'belief', 'believe', 'trust'],
    ['works', 'deeds', 'actions', 'behaviour', 'behavior'],
    ['image of god', 'imago dei', 'divine image', 'human dignity'],
    ['conscience', 'conviction', 'moral sense'],
    ['tongues', 'glossolalia', 'prayer language', 'spiritual language'],
    ['deacon', 'deacons', 'servant leader', 'servant leaders'],
    ['church discipline', 'correction', 'accountability', 'excommunication'],
    ['infant baptism', 'paedobaptism', 'child baptism', 'christening'],
    ['mission', 'evangelism', 'outreach', 'great commission'],
    ['tax', 'taxes', 'taxation', 'render to caesar'],
    ['civil disobedience', 'resistance', 'protest', 'disobey government'],
    ['nationalism', 'patriotism', 'nation', 'country'],
    ['immigrant', 'immigrants', 'migrant', 'migrants', 'refugee', 'refugees', 'foreigner', 'foreigners'],
    ['charity', 'almsgiving', 'aid', 'giving'],
    ['wage', 'wages', 'pay', 'salary', 'compensation'],
    ['invest', 'investing', 'investment', 'investments'],
    ['profit', 'profits', 'earnings', 'business gain'],
    ['property', 'possession', 'possessions', 'ownership'],
    ['sabbath', 'sunday', 'lords day', 'day of rest'],
    ['rest', 'recreation', 'leisure', 'time off'],
    ['unemployment', 'jobless', 'joblessness', 'out of work'],
    ['debt', 'loan', 'loans', 'credit', 'borrowing'],
    ['gambling', 'betting', 'wagering', 'lottery', 'lotteries'],
    ['smoking', 'tobacco', 'cigarettes', 'vaping'],
    ['cannabis', 'marijuana', 'medical marijuana'],
    ['entertainment', 'movies', 'television', 'media'],
    ['social media', 'social networks', 'online platforms'],
    ['anonymity', 'anonymous', 'hidden identity'],
    ['art', 'arts', 'creativity', 'creative work'],
    ['literature', 'books', 'fiction', 'novels', 'reading'],
    ['dance', 'dancing'],
    ['fasting', 'fast', 'abstinence from food'],
    ['meditation', 'contemplation', 'contemplative prayer'],
    ['liturgical', 'liturgy', 'set prayers', 'written prayers'],
    ['silence', 'quiet', 'stillness'],
    ['healing', 'heal', 'cure', 'recovery'],
    ['discernment', 'discern', 'wisdom', 'decision making'],
    ['doubt', 'doubts', 'uncertainty', 'questioning faith'],
    ['suffering', 'pain', 'hardship', 'affliction'],
    ['disability', 'disabled', 'impairment', 'accessibility'],
    ['mental illness', 'mental health', 'depression', 'anxiety'],
    ['therapy', 'counselling', 'counseling', 'psychotherapy'],
    ['lie', 'lying', 'falsehood', 'dishonesty', 'deception'],
    ['stealing', 'theft', 'robbery', 'taking property'],
    ['self defence', 'self defense', 'defending yourself', 'personal protection'],
    ['death penalty', 'capital punishment', 'execution'],
    ['euthanasia', 'assisted dying', 'end of life', 'end of life decisions'],
    ['contraception', 'birth control', 'family planning'],
    ['ivf', 'in vitro fertilisation', 'in vitro fertilization', 'fertility treatment'],
    ['interest', 'usury', 'lending interest'],
    ['oath', 'oaths', 'swearing', 'vow'],
    ['environment', 'creation care', 'ecology', 'climate'],
    ['animals', 'animal welfare', 'creatures'],
    ['cremation', 'burial', 'funeral'],
    ['consumerism', 'materialism', 'overconsumption'],
    ['revenge', 'vengeance', 'retaliation'],
    ['slavery', 'enslavement', 'slaveholding'],
    ['military service', 'armed forces', 'soldiering'],
    ['religious freedom', 'forced religion', 'coerced faith'],
    ['miracle', 'miracles', 'miraculous', 'supernatural'],
    ['tithe', 'tithes', 'tithing', 'ten percent giving'],
    ['resurrection', 'raised from the dead', 'rising again'],
    ['trinity', 'triune god', 'father son and holy spirit'],
    ['gospel', 'good news', 'evangel'],
    ['israel', 'jewish people', 'jews'],
    ['gentile', 'gentiles', 'non jew', 'non jews'],
    ['torah observant', 'law observant', 'keeping torah'],
    ['holy kiss', 'greeting kiss', 'kiss of peace'],
];

const normalizeSearchText = (value = '') => value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[’']/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

const normalizedConcepts = SEARCH_CONCEPTS.map((concept) => concept.map(normalizeSearchText));

const alternativesFor = (term) => {
    const matchingConcepts = normalizedConcepts.filter((entries) => entries.includes(term));
    return matchingConcepts.length ? [...new Set(matchingConcepts.flat())] : [term];
};

const topicSearchText = (topic) => normalizeSearchText([topic.question, topic.shortTitle].filter(Boolean).join(' '));

export const perspectiveMatchesQuery = (topic, query) => {
    const normalizedQuery = normalizeSearchText(query);
    if (!normalizedQuery) return true;

    const searchable = topicSearchText(topic);
    if (searchable.includes(normalizedQuery)) return true;

    const phraseAlternatives = alternativesFor(normalizedQuery);
    if (phraseAlternatives.some((alternative) => searchable.includes(alternative))) return true;

    return normalizedQuery
        .split(' ')
        .filter(Boolean)
        .every((term) => alternativesFor(term).some((alternative) => searchable.includes(alternative)));
};
